import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-zinc-950 font-sans text-stone-100" data-id="element-0" data-mp="2wip5x1c7ng4e">
      <Hero data-id="element-1" data-mp="28tmifcuwat1z" />
      <main data-id="element-2" data-mp="28t4kmbsl46ry">
        <TestimonialsSection data-id="element-3" data-mp="28sur4e8bzhhi" />
        <ProblemSection data-id="element-4" data-mp="23vcjcr61v8b3" />
        <VolumesSection data-id="element-5" data-mp="23vul23bheeqe" />
        <BonusesSection data-id="element-6" data-mp="23ujlygszdv5m" />
        <OfferSection data-id="element-7" data-mp="23t8i6gzjcnei" />
        <GuaranteeSection data-id="element-8" data-mp="3ijxoypkvdyjd" />
        <FaqSection data-id="element-9" data-mp="3ikqz80j1f669" />
        <FinalCtaSection data-id="element-10" data-mp="3ij61k21ff746" />
      </main>
      <Footer data-id="element-11" data-mp="3ii4ppvcl6gle" />
      <StickyCta data-id="element-12" data-mp="3mlax56bfqdtg" />
    </div>;
}